import { render } from "./FlatFeeCalculator.vue?vue&type=template&id=07c219e5"
import script from "./FlatFeeCalculator.vue?vue&type=script&lang=js"
export * from "./FlatFeeCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/FlatFeeCalculator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07c219e5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07c219e5', __exports__)) {
    api.reload('07c219e5', __exports__)
  }
  
  module.hot.accept("./FlatFeeCalculator.vue?vue&type=template&id=07c219e5", () => {
    api.rerender('07c219e5', render)
  })

}


export default __exports__